/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Distribution_BeforeInputs */

const en_us2_progress_report_distribution_before = /** @type {(inputs: Progress_Report_Distribution_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before`)
};

const pt_br2_progress_report_distribution_before = /** @type {(inputs: Progress_Report_Distribution_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes`)
};

const es_419_progress_report_distribution_before = /** @type {(inputs: Progress_Report_Distribution_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes`)
};

const pt_pt2_progress_report_distribution_before = /** @type {(inputs: Progress_Report_Distribution_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes`)
};

const fr_fr2_progress_report_distribution_before = /** @type {(inputs: Progress_Report_Distribution_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avant`)
};

const de_de2_progress_report_distribution_before = /** @type {(inputs: Progress_Report_Distribution_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorher`)
};

const it_it2_progress_report_distribution_before = /** @type {(inputs: Progress_Report_Distribution_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima`)
};

/**
* | output |
* | --- |
* | "Before" |
*
* @param {Progress_Report_Distribution_BeforeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_distribution_before = /** @type {((inputs?: Progress_Report_Distribution_BeforeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Distribution_BeforeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_distribution_before(inputs)
	if (locale === "es-419") return es_419_progress_report_distribution_before(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_distribution_before(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_distribution_before(inputs)
	if (locale === "de-DE") return de_de2_progress_report_distribution_before(inputs)
	if (locale === "it-IT") return it_it2_progress_report_distribution_before(inputs)
	return en_us2_progress_report_distribution_before(inputs)
});
export { progress_report_distribution_before as "progress-report.distribution_before" }